<template>
  <div class='h-mml-leftlistbox'>
    <ejs-tab ref='neTab' @selected="tabClicked($event)" heightAdjustMode='None'>
      <e-tabitems>
        <e-tabitem :header='neHeader' content='#mml-ne-list'></e-tabitem>
        <e-tabitem :header='devHeader' content='#mml-dev-list'></e-tabitem>
        <!-- <e-tabitem :header='clusterHeader' content='#mml-cluster-list'></e-tabitem>
        <e-tabitem :header='ueHeader' content='#mml-ue-list'></e-tabitem> -->
      </e-tabitems>
    </ejs-tab>
    <div id='mml-ne-list' style='display: none'>
      <ejs-listview cssClass='mml-listview-scroll' ref='neListView' :dataSource='curNeData' showIcon='true' :fields='fieldModel' @select='neSelected'></ejs-listview>
    </div>
    <div id='mml-dev-list' style='display: none'>
      <ejs-listview cssClass='mml-listview-scroll' ref='devListView' :dataSource='curDevData' showIcon='true' :fields='fieldModel' @select='devSelected'></ejs-listview>
    </div>
    <!-- <div id='mml-cluster-list' style='display: none'>
    </div>
    <div id='mml-ue-list' style='display: none'>
      <ue-list></ue-list>
    </div> -->
  </div>
</template>

<script>
import { EventBus } from '@/plugins/eventBus.js';
import bus from '../bus.js';
import UeList from './UeList';

export default {
  name: 'ne-list',
  components: {
    UeList
  },
  props: {
    neDatas: {
      type: Array,
      default() {
        return [];
      },
    },
    devDatas: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      fieldModel: {
        text: 'name',
        value: 'id',
        tooltip: 'toolTip',
        iconCss: 'icon'
      },
      neHeader: {
        text: this.$t('MML.ne')
      },
      devHeader: {
        text: this.$t('MML.device')
      },
      clusterHeader: {
        text: this.$t('MML.cluster')
      },
      ueHeader: {
        text: this.$t('MML.ue')
      },
      curDevData: [],
      curNeData: [],
    };
  },
  watch:{
    // 如果不watch 首次更新后加载不出来网元列表 因为数据是异步传过来的 搜索同样有用
    neDatas(newValue, oldValue){
      this.curNeData = newValue;
    },
    devDatas(newValue, oldValue){
      this.curDevData = newValue;
    },
  },
  methods: {
    tabClicked(e) {
      const refs = ['neListView', 'devListView'];
      const curSelectedIndex = e.selectedIndex;
      const curRef = refs[curSelectedIndex];
      if (curRef === 'devListView') {
        this.curDevData = [];
        this.$nextTick(() => {
          this.curDevData = this.devDatas;
        })
      } else {
        this.curNeData = [];
        this.$nextTick(() => {
          this.curNeData = this.neDatas;
        })
      }
    },
    devSelected(args) {
      const node = args.data;
      if (!node) {
        console.err('devData is error!', args);
      }
      this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${node.id}`).then(res => {
        const nodeStatus = res.data?res.data.resultVal:0;
        if(nodeStatus === 0){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('MML.neOffline', [node.name])});
        }
        node.nodeType = 'equipment';
        bus.$emit('loadMoTree', node);
      })
    },
    neSelected(args) {
      const node = args.data;
      if (!node) {
        console.err('neData is error!', args);
      }
      this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${node.id}`).then(res => {
        const nodeStatus = res.data ? res.data.resultVal : 0;
        if(nodeStatus === 0){
          EventBus.$emit('toast', {type: 'warning', content: this.$t('MML.neOffline', [node.name])});
        }
        node.nodeType = 'ne';
        bus.$emit('loadMoTree', node);
      }) 
    },
    queryHssNode() {
      
    }
  }
};
</script>

<style>
.ne-test-con {
  margin:-7px;
}
.listbox-wrap {
  border: 0;
}
</style>
